export const timeReportPermissionUsers = [
  'florian.wermelinger@collana.com',
  'timothy.trowbridge@collana.com',
  'terenzio.pisanelli@collana.com',
];
